import { render, staticRenderFns } from "./ValidationSummary.vue?vue&type=template&id=0a18394f&scoped=true&"
import script from "./ValidationSummary.vue?vue&type=script&lang=js&"
export * from "./ValidationSummary.vue?vue&type=script&lang=js&"
import style0 from "./ValidationSummary.vue?vue&type=style&index=0&id=0a18394f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18394f",
  null
  
)

export default component.exports